import { render } from "./chat_user.vue?vue&type=template&id=6d5447fd&scoped=true"
import script from "./chat_user.vue?vue&type=script&lang=js"
export * from "./chat_user.vue?vue&type=script&lang=js"

import "./chat_user.vue?vue&type=style&index=0&id=6d5447fd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5447fd"]])

export default __exports__